import Vue from 'vue'
import Vuex from 'vuex'
import jwt from 'jsonwebtoken'
var socket;
var pingInterval;
var recondelay = 50;
var apiKey = 'MTMzN2JveGx1bmNoc2FsYWQ=';
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    loggedIn: false,
    darktheme: false,
    websocketConnected: false,
    logs: [],
    sessions: []
  },
  actions: {
    LOGIN: function ({
                       commit
                     }) {
      commit('SET_LOGGED_IN', true)
    },
    LOGOUT: function ({
                        commit
                      }) {
      commit('SET_LOGGED_IN', false)
    },
    GET_LATEST_LOGS: function ({
                                 commit
                               }) {


    }
  },
  mutations: {
    addLog(state, text) {
      if(state.logs.length > 50){
        state.logs.shift();
      }
      state.logs.push(text)
    },
    setSessions(state, data) {
      state.sessions = data;
    },
    clearLogs(state) {
      state.logs = [];
    },
    SET_LOGGED_IN: function (state, loggedin) {
      state.loggedIn = loggedin
    },
    SET_SOCKET_CONNECTED: function (state, connected) {
      state.websocketConnected = connected;
    }
  },
  getters: {
    lastlog: state => {
      return state.logs[state.logs.length - 1];
    },
    logs: state => {
      return state.logs;
    },
    loggedin: state => {
      return state.loggedIn
    },
    wsconnected: state => {
      return state.websocketConnected;
    },
    sessions: state=> {
      return state.sessions;
    }
  }
})

function connect(){
  socket = new WebSocket("wss://vrc.api.maxis.io/ws")

   socket.onmessage = function(msg){
    var state = socket.readyState;

    if(state !== 1){
      store.commit('SET_SOCKET_CONNECTED', false);
    }else{
      store.commit('SET_SOCKET_CONNECTED', true);
    }

    var msg = JSON.parse(msg.data);

    if(msg.err){
      this.$root.$emit('snackbar', msg.m);
    }

    switch(msg.type){
      case "getsessions":
        var d = msg.d;
        store.commit('setSessions', d);
        break;
      case "getlast":
        var d = msg.d;

        store.commit('clearLogs');
        d.forEach((entry) => {
          store.commit('addLog', entry);
        })

        break;
      case "log":
        store.commit('addLog', msg.d);

        break;
      case "connected":
        socket.send(JSON.stringify({"type": "getlast"}));
        pingInterval = setInterval(()=> {
          var token = localStorage.getItem('jwtToken');
          var decoded = jwt.decode(token.split(" ")[1]);
          socket.send(JSON.stringify({
            "type": "session",
            "d": {
              "uid": decoded._id,
              "apps": ["VSS WebPanel"]
            }
          }));
        }, 1000)
        break;
    }
  }
  socket.onerror = function(err){
    console.error('Socket encountered error: ', err.message, 'Closing socket');
    socket.close();
    recondelay = recondelay * 1.5
    if (recondelay > 10000) {
      recondelay = 1000;
    }
  }

  socket.onclose = function(err){
    if(pingInterval){
      clearInterval(pingInterval)
    }
    console.log('Socket is closed. Reconnect will be attempted in ' + recondelay + ' ms.', err.reason);
    store.commit('SET_SOCKET_CONNECTED', false);
    setTimeout(function() {
      socket = undefined;
      connect();
    }, recondelay);
  }

  socket.onopen = function(err){
    console.log("CONNECTED TO WebSocket");
    store.commit('SET_SOCKET_CONNECTED', true);
    recondelay = 50;
  }
}

connect();

export default store



// WEBPACK FOOTER //
// ./src/stores/store.js